import React, { Component } from 'react';
import PropTypes from 'prop-types';
import Dropdown from '@s/Dropdown';
import Message from '@s/Message';
import { setTerminals } from 'checkout/actions/payment';


class TerminalSelect extends Component {
    render() {
        return(
            <div className="input">
                <div className="input__horizontal">
                    <label className="input__label" htmlFor="terminalSelect">EMV Terminal</label>
                    {this.props.terminals.length ?
                        <Dropdown
                            id="terminalSelect"
                            className="input__control"
                            value={this.props.terminal}
                            options={this.props.terminals}
                            onChange={this.props.onTerminalSelect}
                            placeholder="Select Terminal"
                        />
                        :
                        <Message caution inlineText title="No terminal avaliable" />
                    }
                </div>
            </div>
        )
    }
}

TerminalSelect.propTypes = {
    sellerId: PropTypes.any,
    terminal: PropTypes.string,
    apiUrl: PropTypes.string.isRequired,
    onTerminalSelect: PropTypes.func.isRequired,
};

TerminalSelect.defaultProps = {
};

export default TerminalSelect;
